function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.12645 0 0 .1765 -6.4225 -13.441)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m102.7 147.84h34.19l1.6216-2.4325-0.67569-5.9461-3.1082-8.2434-3.7839-3.919-4.1893-2.0271-3.6487-0.94596-3.2433-0.13514-4.3244 0.40541-3.919 1.4865-3.3784 2.2974-3.1082 3.919-2.2973 4.4595-1.0811 7.2974v1.4865z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), /*#__PURE__*/React.createElement("g", {
  fillOpacity: 0,
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "m66.869 90.91 3.0848-1.5931 98.937 0.09394 2.6646 1.4382 1.2172 2.307 0.36931 63.164-1.2067 3.199-3.2192 1.3765h-99.008l-2.7224-1.3663-1.3663-2.6412v-63.37z",
  strokeWidth: 0.25916
}), /*#__PURE__*/React.createElement("rect", {
  x: 70.326,
  y: 94.038,
  width: 98.005,
  height: 62.329,
  ry: 0,
  strokeWidth: 0.23008
})), /*#__PURE__*/React.createElement("circle", {
  cx: 119.53,
  cy: 112.32,
  r: 10.623,
  stroke: "#000",
  strokeWidth: 0.265
}), /*#__PURE__*/React.createElement("path", {
  d: "m57.264 162.69 124.55 0.061-5.7332 6.2295h-112.54z",
  stroke: "#000",
  strokeWidth: 0.265
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.86555 0 0 .86555 15.075 12.695)",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 120.46,
  cy: 85.19,
  r: 8.6374,
  strokeWidth: 0.31704
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120.46,
  cy: 85.19,
  r: 6.0042,
  fill: "#fff",
  strokeWidth: 0.22039
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120.34,
  cy: 85.338,
  r: 3.1791,
  strokeWidth: 0.11669
})), /*#__PURE__*/React.createElement("path", {
  transform: "scale(.26458)",
  d: "m259.27 604.67c-4.2297-2.1898-6.1293-3.9657-7.9354-7.4184l-2.3745-4.5394-0.0465-119.25-0.0465-119.25 2.5863-5.1039c2.0377-4.0212 3.669-5.6525 7.6902-7.6902l5.1039-2.5863h372.97l5.0991 2.5839c3.7335 1.8919 5.7107 3.7538 7.3827 6.952l2.2836 4.3681 0.76405 118.44 0.76404 118.44-2.1798 6.242c-2.1638 6.1963-2.2294 6.2623-8.9534 9.0197l-6.7736 2.7777-370.77-0.1128-5.5609-2.879zm377.88-131.43v-118.96h-371.8v237.91h371.8z",
  stroke: "#000",
  strokeWidth: 1.0316
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.33806 0 0 .33806 103.05 100.66)",
  fillOpacity: 0,
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "m66.869 90.91 3.0848-1.5931 98.937 0.09394 2.6646 1.4382 1.2172 2.307 0.36931 63.164-1.2067 3.199-3.2192 1.3765h-99.008l-2.7224-1.3663-1.3663-2.6412v-63.37z",
  strokeWidth: 0.25916
}), /*#__PURE__*/React.createElement("rect", {
  x: 70.326,
  y: 94.038,
  width: 98.005,
  height: 62.329,
  ry: 0,
  strokeWidth: 0.23008
})), /*#__PURE__*/React.createElement("path", {
  d: "m126.83 132.45h33.132v21.071h-33.132z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m147.05 138.63a3.5912 3.5912 0 0 1-3.5912 3.5912 3.5912 3.5912 0 0 1-3.5912-3.5912 3.5912 3.5912 0 0 1 3.5912-3.5912 3.5912 3.5912 0 0 1 3.5912 3.5912"
}), /*#__PURE__*/React.createElement("path", {
  d: "m137.77 150.64h11.558l0.54821-0.82233-0.22842-2.0101-1.0507-2.7868-1.2792-1.3248-1.4162-0.68527-1.2335-0.31979-1.0964-0.0457-1.4619 0.13705-1.3248 0.50253-1.1421 0.77664-1.0507 1.3248-0.77663 1.5076-0.36548 2.467v0.50253z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m126.24 154.74c-0.37832-0.19587-0.54824-0.35471-0.70978-0.66354l-0.21238-0.40602-4e-3 -10.666-4e-3 -10.666 0.23134-0.45652c0.18226-0.35967 0.32817-0.50558 0.68784-0.68785l0.45652-0.23133h33.36l0.45609 0.23112c0.33394 0.16922 0.51079 0.33575 0.66034 0.62182l0.20426 0.3907 0.0683 10.594 0.0683 10.594-0.19497 0.55831c-0.19354 0.55423-0.1994 0.56013-0.80084 0.80677l-0.60586 0.24845-33.164-0.01-0.49739-0.25751zm33.799-11.756v-10.64h-33.256v21.28h33.256z"
})));

var SvgVideoChat = function SvgVideoChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-chat.19b3e00b.svg";
export { ForwardRef as ReactComponent };